export default __webpack_public_path__ + "static/media/Llovizna.b9297422.svg";